import React, { useState } from "react";
import { Link } from "react-router-dom";

function TrackOrder() {
  const [showDetails, setShowDetails] = useState(false);
  const [generatedOrderNumber] = useState(
    `#${Math.floor(10000 + Math.random() * 90000)}`
  );

  const estimatedDelivery = (() => {
    const d = new Date();
    d.setDate(d.getDate() + 4);
    return d.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  })();

  const steps = [
    "Order Placed",
    "Processing",
    "Packed",
    "Out for Delivery",
    "Delivered",
  ];

  const currentStep = Math.floor(Math.random() * 4) + 1;

  const randomItems = [
    { name: "HP LaserJet Toner", price: 49.99, qty: 1 },
    { name: "Canon Photo Paper", price: 12.99, qty: 2 },
  ];

  return (
    <div className="track-new-wrapper">
      <div className="container">
        <h2 className="heading">Track Your Order</h2>

        {/* STEP 1 — INPUT BOX */}
        {!showDetails && (
          <div className="search-card">
            <p className="label-text">Enter your order number:</p>

            <input type="text" className="track-input" placeholder="#12345" />

            <button
              className="btn-primary"
              onClick={() => setShowDetails(true)}
            >
              Track Order
            </button>

            <Link to="/shop" className="link-back">
              ← Back to Shopping
            </Link>
          </div>
        )}

        {/* STEP 2 — TRACKING UI */}
        {showDetails && (
          <div className="result-area">
            {/* ORDER TAG */}
            <div className="order-info">
              <span className="small-label">Order Number</span>
              <div className="order-code">{generatedOrderNumber}</div>
            </div>

            {/* TIMELINE */}
            <div className="progress-container">
              <div className="progress-line" />
              {steps.map((step, i) => (
                <div
                  key={i}
                  className={`progress-step ${
                    i <= currentStep ? "active" : ""
                  }`}
                >
                  <div className="step-circle">
                    {i < currentStep ? "✓" : i + 1}
                  </div>
                  <span className="step-label">{step}</span>
                </div>
              ))}
            </div>

            {/* DELIVERY ESTIMATE */}
            <div className="delivery-card">
              <h3>Estimated Delivery</h3>
              <div className="delivery-date">{estimatedDelivery}</div>
              <p className="delivery-text">
                Your package is moving through the network 🚚
              </p>
            </div>

            {/* ORDER SUMMARY */}
            <div className="summary-card">
              <h3>Order Summary</h3>

              {randomItems.map((item, i) => (
                <div className="summary-row" key={i}>
                  <span>
                    {item.name} × {item.qty}
                  </span>
                  <strong>${(item.price * item.qty).toFixed(2)}</strong>
                </div>
              ))}

              <div className="summary-total">
                <span>Total Paid</span>
                <strong>
                  $
                  {randomItems
                    .reduce((a, b) => a + b.price * b.qty, 0)
                    .toFixed(2)}
                </strong>
              </div>
            </div>

            {/* BUTTON ROW */}
            <div className="btn-row">
              <Link to="/my-account" className="btn-primary">
                Back to Account
              </Link>
              <Link to="/shop" className="btn-outline">
                Continue Shopping
              </Link>
            </div>
          </div>
        )}
      </div>

      {/* STYLING */}
      <style>{`
        .track-new-wrapper {
          padding: 70px 0;
          background: #f4f7fb;
        }

        .heading {
          text-align: center;
          font-size: 34px;
          font-weight: 700;
          margin-bottom: 30px;
        }

        .search-card {
          max-width: 430px;
          margin: 0 auto;
          padding: 30px;
          background: #fff;
          border-radius: 16px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.07);
          text-align: center;
        }

        .label-text {
          color: #555;
          margin-bottom: 10px;
        }

        .track-input {
          width: 100%;
          padding: 14px;
          border-radius: 12px;
          border: 1px solid #ccc;
          text-align: center;
          font-size: 18px;
          margin-bottom: 20px;
        }

        .btn-primary {
          background: #0b61d6;
          padding: 14px 26px;
          border-radius: 10px;
          color: #fff;
          font-weight: 600;
          border: none;
          display: inline-block;
          text-decoration: none;
          transition: .3s;
        }
        .btn-primary:hover {
          background: #094bb0;
        }

        .btn-outline {
          padding: 14px 26px;
          border-radius: 10px;
          border: 2px solid #0b61d6;
          color: #0b61d6;
          font-weight: 600;
          text-decoration: none;
          transition: .3s;
        }
        .btn-outline:hover {
          background: #0b61d6;
          color: #fff;
        }

        .link-back {
          display: block;
          margin-top: 14px;
          color: #0b61d6;
          font-size: 14px;
        }

        /* ORDER INFO */
        .order-info {
          text-align: center;
          margin-bottom: 30px;
        }

        .small-label {
          color: #888;
          font-size: 14px;
          margin-bottom: 5px;
          display: block;
        }

        .order-code {
          display: inline-block;
          background: #eaf4ff;
          padding: 10px 22px;
          border-radius: 12px;
          font-weight: 700;
          font-size: 20px;
          color: #0b61d6;
        }

        /* PROGRESS BAR */
        .progress-container {
          position: relative;
          display: flex;
          justify-content: space-between;
          margin: 50px 0 40px;
          padding: 0 20px;
        }

        .progress-line {
          position: absolute;
          top: 22px;
          left: 40px;
          right: 40px;
          height: 4px;
          background: #d9e2f2;
          z-index: 1;
        }

        .progress-step {
          text-align: center;
          flex: 1;
          z-index: 2;
        }

        .step-circle {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: #c8d3e6;
          color: white;
          font-weight: 700;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 6px;
          transition: .3s;
        }

        .progress-step.active .step-circle {
          background: #0b61d6;
          transform: scale(1.1);
        }

        .step-label {
          font-size: 14px;
          color: #555;
        }

        .progress-step.active .step-label {
          font-weight: 700;
          color: #0b61d6;
        }

        /* DELIVERY CARD */
        .delivery-card {
          background: #fff;
          padding: 24px;
          border-radius: 16px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.05);
          text-align: center;
          margin-bottom: 25px;
        }

        .delivery-date {
          font-size: 22px;
          margin-top: 6px;
          font-weight: 700;
          color: #0b61d6;
        }

        .delivery-text {
          color: #666;
          margin-top: 6px;
        }

        /* SUMMARY CARD */
        .summary-card {
          background: #fff;
          padding: 24px;
          border-radius: 16px;
          box-shadow: 0 8px 24px rgba(0,0,0,0.05);
          margin-bottom: 35px;
          max-width: 680px;
          margin-left: auto;
          margin-right: auto;
        }

        .summary-row {
          display: flex;
          justify-content: space-between;
          padding: 7px 0;
        }

        .summary-total {
          margin-top: 12px;
          border-top: 1px solid #ddd;
          padding-top: 12px;
          font-size: 18px;
          font-weight: 700;
          display: flex;
          justify-content: space-between;
        }

        .btn-row {
          display: flex;
          justify-content: center;
          gap: 15px;
          margin-top: 20px;
        }
      `}</style>
    </div>
  );
}

export default TrackOrder;
